module.exports = __webpack_public_path__ + "static/Perso-1-e79f3faf60fcc2e07cb39928086a0edc.png";